<template>
  <div
    class="relative space-y-12 rounded-lg border border-static-default-mid px-24 py-32 md:grid md:grid-cols-[minmax(140px,250px)_1fr_1fr_auto] md:items-center md:gap-x-16 md:space-y-0"
  >
    <div class="flex items-center gap-8">
      <div class="rounded-full overflow-hidden">
        <RevIllustration
          alt=""
          class="size-32 shrink-0"
          :height="32"
          :src="logoSrc"
          :width="32"
        />
      </div>

      <span class="heading-2">{{ name }}</span>
    </div>

    <div class="space-y-2">
      <div class="flex items-baseline gap-4">
        <span class="body-1 text-static-default-low md:hidden">
          {{ i18n(translations.colPhoneCost) }}:
        </span>
        <span class="body-1-bold">{{ phoneCost }}</span>
        <span
          v-if="phoneCostStrikethrough"
          class="body-1 text-static-default-low line-through"
        >
          {{ phoneCostStrikethrough }}
        </span>
      </div>
      <p v-if="phoneDiscountLabel" class="caption-bold text-static-success-hi">
        {{ phoneDiscountLabel }}
      </p>
    </div>

    <div class="flex gap-4">
      <span class="caption text-static-default-low md:hidden">
        {{ i18n(translations.colPlanCost) }}:
      </span>
      <span class="body-1-bold grow">{{ planCost }}</span>
    </div>

    <div class="flex flex-col gap-4 md:items-end md:text-right">
      <RevTag
        v-if="savingsAmount"
        class="absolute -top-12 right-24"
        :label="i18n(translations.savingsLabel, { amount: savingsAmount })"
        size="large"
        variant="primary"
      />

      <span class="punchline text-[2.5rem] leading-[2.5rem]">
        {{ totalCost }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { RevTag } from '@ds/components/Tag'

import translations from './ComparisonRow.translations'

defineProps<{
  name: string
  logoSrc: string
  phoneCost: string
  phoneCostStrikethrough?: string
  phoneDiscountLabel?: string
  planCost: string
  totalCost: string
  savingsAmount: string
}>()

const i18n = useI18n()
</script>
